<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="6000"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-row align="center" justify="start" no-gutters >
              <v-col :cols="12" :md="4" :sm="4" class="pa-2" v-if="organisationType === 'GOVERMNENT' ||
                  organisationType === 'COOP BANK'">
                <v-text-field v-model="search" append-icon="search" label="Search by Grower" class="w-100"></v-text-field>
              </v-col>

              <v-col :cols="12" :md="2" :sm="2" class="pa-2">
                <v-text-field
                  label="Start Date"
                  v-model="startDate"
                  type="date"
                  class="w-100"
                ></v-text-field>
              </v-col>

              <v-col :cols="12" :md="2" :sm="2" class="pa-2">
                <v-text-field
                  label="End Date"
                  v-model="endDate"
                  type="date"
                  class="w-100"
                ></v-text-field>
              </v-col>

              <v-col :cols="12" :md="1.5" :sm="2" class="pa-2">
                <v-btn @click="this.getBuyerEslips" class="w-100 secondary">Search</v-btn>
              </v-col>

              <v-col :cols="12" :md="1.5" :sm="2" class="pa-2">
                <v-btn class="w-100 primary"  @click="exportExcel">Download</v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
			<v-data-table :headers="headers" :items="eslips" :hide-default-footer="true" class="elevation-1">
				<template v-slot:[`item.dateBought`]="{ item }">
				  <span>{{ formatDate(item.dateBought) }}</span>
				</template>
				<template v-slot:[`item.actions`]="{ item }">
				  <v-btn @click="goToStock(item)" color="primary">View</v-btn>
				</template>
			  </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" sm="9">
                <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right"
                              prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import _ from 'lodash'
import * as XLSX from 'xlsx'

export default {
	name: 'StockDetailStatusTracker2',
	data: function () {
		return {
			headers: [
				{
					text: 'Delivery Date',
					value: 'dateBought'
				},
				{
					text: 'Grower Code',
					value: 'growerCode'
				},
				{
					text: 'Eslip#',
					value: 'eslipNumber'
				},
				{
					text: 'Grower Outturn',
					value: 'growerOutturnNumber'
				},
				{
					text: 'Miller',
					value: 'millerCode'
				},
				{
					text: 'Parchment Outturn',
					value: 'parchmentOutturnNumber'
				},
				{
					text: 'Clean Coffee',
					value: 'cleanCoffeeOuttun'
				},
				{
					text: 'Grade',
					value: 'cleanGrade'
				},
				{
					text: 'Warrant Number',
					value: 'warrantNumber'
				},
				{
					text: 'Lot No',
					value: 'lotNumber'
				},
				{
					text: 'Amount',
					value: 'price'
				},
				{
					text: 'Date Bought',
					value: 'dateBought'
				},
				{
					text: 'STATUS',
					value: 'status'
				},
				{
					text: 'Actions',
					value: 'actions'
				}
			],
			startdate: '',
			eslips: [],
			growerCodes: [],
			seasons: [],
			startDate: '',
			endDate: '',
			message: '',
			loading: false,
			totalEslips: 0,
			snackbar: false,
			snackbarColor: '',
			messsage: '',
      		currentYear: new Date(),
			pagination: {
				sortBy: 'id',
				descending: true
			},
			dialog: false,
			eslip: {},
			search: '',
			page: 1,
			totalPages: 0,
			pageSize: 7,
			pageSizes: [5, 10],
			theUser: [],
      organisationType: '',
      organisationCode: ''
		}
	},
	watch: {
		/* search: function (newSearch) {
			// Reset page number when search changes
			this.page = 1
			this.debouncedGetEslips()
		} */
		// search: function (oldValue, newValue) {
		//   this.debouncedGetAnswer()
		// }
	},
	mounted () {
		this.getLoggedInUser()
		this.getBuyerEslips()
		this.getGrowerCodes()
		this.getSeasons()
	},
	methods: {
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
      this.organisationType = this.theUser.organisation.organisationType.name
      this.organisationCode = this.theUser.organisation.organisationCode
			// this.curUserN = this.curUser.firstName
		},
		goToStock (item) {
			console.log('item --->> ', item.id)
			this.$router.push('/grower/stock2/' + item.id)
		},
		getSeasons () {
			this.seasons.push('2023/2024')
			this.seasons.push('2024/2025')
			const month = this.currentYear.getMonth()
			const year = this.currentYear.getFullYear()
			if (month < 10) {
				this.seasons.push(year + '/' + (year + 1))
				this.seasons.push(year + 1 + '/' + (year + 2))
			} else {
				this.seasons.push(year + 1 + '/' + (year + 2))
				this.seasons.push(year + 3 + '/' + (year + 4))
			}
		},
		getGrowerCodes () {
			const url = config.serverURI + '/organization/get-marketers'
			axios.get(url)
				.then(response => {
					console.log('FCS - ', response.data)
					// this.growerCodes = response.data
					response.data.forEach(x => {
						console.log('->> ', x.organisationCode)
						this.growerCodes.push(x.organisationCode)
					})
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.growerCodes
		},
		getOrg () {
			const url = config.serverURI + '/growerstatus/org'
			axios.get(url, {})
				.then(response => {
					this.code = response.data.code
					this.name = response.data.name
					console.log('Organisation Code===>' + this.code + ' Name==> ' + this.name)
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.grower
		},
		exportExcel () {
			// Define worksheet and workbook
			const ws = XLSX.utils.json_to_sheet(this.eslips
				//   {
				//     header: Object.keys(this.headers)
				//   }
			)
			const wb = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

			// Export workbook to file
			XLSX.writeFile(wb, 'Stock_Status_' + '_Tracker' + Date.now() + '.xlsx')
		},
		checkDate (event, dte) {},

		// 	formatDate(dateObj) {
		//   const day = dateObj.dayOfMonth < 10 ? `0${dateObj.dayOfMonth}` : dateObj.dayOfMonth;
		//   const monthShort = dateObj.month.substring(0, 3).toUpperCase();
		//   const year = dateObj.year.toString().slice(-2);
		//   return `${day}-${monthShort}-${year}`;
		// },
		formatDate (timestamp) {
			const date = new Date(timestamp)
			const options = {
				day: '2-digit',
				month: 'short',
				year: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				hour12: false
			}
			return date.toLocaleString('en-GB', options).replace(',', '') // Adjust for desired format
		},
		getRequestParams (name, page, pageSize) {
			const params = {}
			if (page) {
				params.page = page - 1
			}
			if (pageSize) {
				params.size = pageSize
			}
			if (name) {
				params.eslipNumber = name
			}
			return params
		},
		getRequestParams2 (name, page, pageSize, startDate, endDate) {
			const params = {}
			if (page) {
				params.page = page - 1
			}
			if (pageSize) {
				params.size = pageSize
			}
			if (name) {
				params.growerCode = name
			}
			if (startDate) {
				params.startDate = startDate
			}
			if (endDate) {
				params.endDate = endDate
			}
			return params
		},
		getBuyerEslips () {
			// const params = this.getRequestParams(this.search, this.page, this.pageSize)
      // name, page, pageSize, startDate, endDate
      console.log("start - ", this.startDate)
      console.log("end - ", this.endDate)

			let params = this.getRequestParams2(this.search, this.page, this.pageSize, this.startDate, this.endDate)
			if (this.organisationType !== 'GOVERMENT' && this.organisationType !== 'COOP BANK') {
				params = this.getRequestParams2(this.organisationCode, this.page, this.pageSize, this.startDate, this.endDate)
			}

			// const params = this.getRequestParams2(this.search, this.page, this.pageSize, this.startDate, this.endDate)
			console.log('params - ' + params)
			const url = config.serverURI + '/growerstatus/buyer2'
			axios.get(url, { params })
				.then(response => {
					console.log('Stock Status tracker 201 data', response.data)
					const {
						items,
						totalPages
					} = response.data
					this.eslips = items
					this.totalPages = totalPages
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.eslips
		},
		debouncedGetEslips: _.debounce(function () {
			this.getBuyerEslips()
		}, 500),
		triggerDownload (item) {
			const url = config.serverURI + '/eslip/download/' + item.id
			axios({
				url: url,
				method: 'POST',
				responseType: 'blob'
			})
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = item.buyer.organisationName + '_' + item.created + '.pdf'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		displayEslipDetails (item) {
			this.dialog = true
			this.eslip = item
		},
		hideDialog () {
			this.dialog = false
		},
		handlePageChange (value) {
			this.page = value
			this.getBuyerEslips()
		},
		handlePageSizeChange (size) {
			this.pageSize = size
			this.page = 1
			this.getBuyerEslips()
		}
	}
	// created: function () {
	//   this.debouncedGetAnswer = _.debounce(this.getGrowerStatement, 1000)
	// },

}

</script>
<style>
.search-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
}

.search-box {
  flex: 1;
  margin-right: 1em;
}

.date-filters {
  display: flex;
  gap: 1em;
}
</style>
